const CREATED_AT_KEYS = ['createdDate', 'createdAt', 'insertTime', 'createTime', 'createdTime'];
const CREATOR_NAME_KEYS = [
  'createdByName',
  'careName',
  'creatorName',
  'createdBy',
  'insertUserName',
  'createdByUser',
  'createdUserName',
];

/**
 * Chuẩn hóa ngày tạo và tên người tạo từ các DTO khác nhau trong hệ thống.
 * @returns {{ createdAt: *, creator: string } | null}
 */
export function resolveRecordCreatedMeta(record, { recordId } = {}) {
  if (!record || typeof record !== 'object') {
    return null;
  }

  const id = recordId ?? record.id;
  if (id == null || id === '' || Number(id) <= 0) {
    return null;
  }

  let createdAt = null;
  for (const key of CREATED_AT_KEYS) {
    if (record[key] != null && record[key] !== '') {
      createdAt = record[key];
      break;
    }
  }
  if (!createdAt) {
    return null;
  }

  let creator = null;
  for (const key of CREATOR_NAME_KEYS) {
    const value = record[key];
    if (value != null && String(value).trim() !== '') {
      creator = String(value).trim();
      break;
    }
  }

  return {
    createdAt,
    creator: creator || '—',
  };
}
